import type { InputActionMeta } from "react-select";

import { User } from "../../../graphql";
import { useUserSearchSelect } from "../../../hooks/useUserSearchSelect";

type CoachingUserOptions = {
  userOptions: { label: string; value: string }[];
  userOptionsLoading: boolean;
  onInputChange: (value: string, actionMeta: InputActionMeta) => void;
};

export const formatUserOption = (
  user: Pick<User, "id" | "email" | "fullName">
): { label: string; value: string } => {
  if (user.fullName === "") {
    return {
      label: `${user.email}`,
      value: user.id,
    };
  }
  return {
    label: `${user.fullName} - ${user.email}`,
    value: user.id,
  };
};

const useCoachingUserOptions = (
  filterUserIds?: string[]
): CoachingUserOptions => {
  const { users, loading, onInputChange } = useUserSearchSelect({
    excludeUserIds: filterUserIds,
  });

  const userOptions = users.map(formatUserOption);

  return {
    userOptions,
    userOptionsLoading: loading,
    onInputChange,
  };
};

export default useCoachingUserOptions;
